import { useState } from "react";
import { toast } from "sonner";
import { api, err } from "../../lib/api";

export default function AdminSecurity() {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const set = k => e => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    if (f.new_password !== f.confirm) return toast.error("New passwords do not match");
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed. Use the new password next time you log in.");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (e) { toast.error(err(e)); }
  };
  return (
    <section className="admin-section"><h2>Change admin password</h2>
      <div className="admin-form">
        <label>Current password<input type="password" value={f.current_password} onChange={set("current_password")} data-testid="current-password-input" /></label>
        <label>New password (min 8)<input type="password" value={f.new_password} onChange={set("new_password")} data-testid="new-password-input" /></label>
        <label>Confirm new password<input type="password" value={f.confirm} onChange={set("confirm")} data-testid="confirm-password-input" /></label>
        <div className="full"><button className="btn green" onClick={save} data-testid="change-password-button">Change password</button></div>
      </div>
    </section>
  );
}
